import { buildReceiptFromProfile } from "./membership";

export function paymentRecordToReceipt(payment) {
  if (!payment) return null;

  return {
    receiptId: payment.paymentId || payment.id,
    orderId: payment.orderId || "-",
    planName: payment.planName || "Karanki Premium (1 year)",
    amount: payment.amount ?? null,
    originalAmount: payment.originalAmount ?? payment.amount ?? null,
    baseAmount: payment.baseAmount ?? null,
    discountAmount: payment.discountAmount ?? 0,
    savingsAmount: payment.savingsAmount ?? 0,
    gstAmount: payment.gstAmount ?? null,
    gstPercent: payment.gstPercent ?? null,
    currency: payment.currency || "INR",
    couponCode: payment.couponCode || "",
    paidAt: payment.paidAt,
    validFrom: payment.membershipStartedAt || payment.paidAt,
    validUntil: payment.membershipExpiresAt,
    memberName: payment.memberName || "Member",
    paymentMethod: payment.methodLabel || payment.method,
    paymentMethodDetail: payment.methodDetail || "",
    status: payment.status,
    environment: payment.environment,
  };
}

export function mergePaymentHistory(payments, profile) {
  const list = [...(payments || [])];
  const knownIds = new Set(
    list.map((item) => item.paymentId || item.id).filter(Boolean)
  );

  const legacy = buildReceiptFromProfile(profile);
  if (profile?.lastPaymentId && !knownIds.has(profile.lastPaymentId)) {
    list.push({
      id: profile.lastPaymentId,
      paymentId: profile.lastPaymentId,
      orderId: profile.lastOrderId,
      planName: legacy?.planName,
      amount: profile.lastPaymentAmount,
      originalAmount: profile.lastPaymentAmount,
      currency: profile.lastPaymentCurrency || "INR",
      paidAt: profile.membershipStartedAt || profile.membershipUpdatedAt,
      membershipStartedAt: profile.membershipStartedAt,
      membershipExpiresAt: profile.membershipExpiresAt,
      memberName: profile.fullName,
      methodLabel: "",
      method: "",
      status: "captured",
      isLegacy: true,
    });
  }

  return list.sort((a, b) => {
    const aTime = new Date(a.paidAt || 0).getTime();
    const bTime = new Date(b.paidAt || 0).getTime();
    return bTime - aTime;
  });
}
